import { cardClass } from './dashboardTokens';

const shimmer = 'animate-pulse rounded-lg bg-[#EEF0F3]';

export const DashboardSkeleton = () => (
  <div className="space-y-5">
    <div className={cardClass}>
      <div className={`${shimmer} h-4 w-32`} />
      <div className={`${shimmer} mt-3 h-8 w-64`} />
      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <div key={i} className={`${shimmer} h-16`} />
        ))}
      </div>
    </div>
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {Array.from({ length: 8 }).map((_, i) => (
        <div key={i} className={`${shimmer} h-28 rounded-2xl`} />
      ))}
    </div>
    <div className="grid gap-4 lg:grid-cols-2">
      <div className={`${shimmer} h-80 rounded-2xl`} />
      <div className={`${shimmer} h-80 rounded-2xl`} />
    </div>
    <div className={`${shimmer} h-48 rounded-2xl`} />
  </div>
);
